export enum ExcludedApplicationReason {
    ADDITIONAL_PASSPORT = 'P',
    PAGES_FULL = 'V'
}

export enum Country {
    ESTONIA = 'EST'
}

export enum ClassifierGroup {
    PLACE_OF_BIRTH = 'synnikoht'
}

export enum ApplicationReason {
    DATA_HAS_CHANGED = 'M',
    LOST_STOLEN_DESTROYED = 'K',
    OTHER_REASON = 'U'
}
